// src/components/Dashboard/Dashboard.js
import React, { useEffect, useState } from "react";
import { Grid, Typography, Box, useMediaQuery, useTheme } from "@mui/material";
import { AttachMoney, People, Favorite, Campaign } from "@mui/icons-material";
import StatCard from "../statcard/statcard";
import PieChartCard from "../PieChart/Piechart";
import SummaryCard from "../Summarycard/SummaryCard";
import apiEndpoints from "../../apiconfig";

function Dashboard() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "lg"));
  const isDesktop = useMediaQuery(theme.breakpoints.up("lg"));

  const [dashboardData, setDashboardData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(apiEndpoints.dashboard, { method: "GET" });
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        setDashboardData(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;
  if (!dashboardData) return <div>No data available</div>;

  const statsData = [
    {
      title: "Total Donation",
      value: `₹${dashboardData.total_donation}`,
      icon: <AttachMoney sx={{ fontSize: 28 }} />,
      growth: `₹${dashboardData.performance_summary.monthly_donation} this month`,
    },
    {
      title: "Active Volunteers",
      value: dashboardData.active_volunteers,
      icon: <People sx={{ fontSize: 28 }} />,
      growth: `${dashboardData.performance_summary.volunteer_retention} active this month`,
    },
    {
      title: "No of Donors",
      value: dashboardData.donor_count,
      icon: <Favorite sx={{ fontSize: 28 }} />,
      growth: `${dashboardData.donor_count} unique donors`,
    },
    {
      title: "Ongoing Causes",
      value: dashboardData.ongoing_causes,
      icon: <Campaign sx={{ fontSize: 28 }} />,
      growth: `${dashboardData.performance_summary.active_campaigns} active campaigns`,
    },
  ];

  return (
    <Box sx={{ p: isMobile ? 2 : 3, width:"100%" ,maxWidth:'100%'}}>
      {/* Header */}
      <Box sx={{ mb: 4 }}>
        <Typography
          variant={isMobile ? "h4" : "h3"}
          sx={{
            fontWeight: "bold",
            color: "#00B894",
            mb: 1,
            textAlign: "center",
          }}
        >
          DEVI CHANDRAN
        </Typography>
        <Typography
          variant="body1"
          sx={{
            color: "#666",
            textAlign: "center",
            fontSize: isMobile ? "1rem" : "1.1rem",
          }}
        >
          PUBLIC WELFARE TRUST
        </Typography>
      </Box>

      {/* Stats Cards */}
      <Grid
        container
        width={"100%"}
        spacing={2}
        justifyContent={'center'}
        sx={{ mb: 4 }}
      >
        {statsData.map((stat, index) => (
          <Grid
            item
            key={index}
            xs={12} // Full width on mobile
            sm={6} // 2 per row on small screens
            md={3} // 4 in a row from medium screens onward
            lg={3}
            xl={3}
          >
            <Box sx={{ height: "100%" }}>
              <StatCard
                title={stat.title}
                value={stat.value}
                icon={stat.icon}
                growth={stat.growth}
              />
            </Box>
          </Grid>
        ))}
      </Grid>

      {/* Charts Section */}
      <Box
        sx={{
          display: "flex",
          flexDirection: isDesktop ? "row" : "column",
          gap: 2,
          width: "100%",
        }}
      >
        <Box
          sx={{
            width: isDesktop ? "48%" : "100%",
            minWidth: isDesktop ? "49%" : "100%",
          }}
        >
          <PieChartCard
            data={dashboardData.donation_distribution}
            sx={{
              height: isDesktop ? "400px" : "auto",
              minHeight: "350px",
            }}
          />
        </Box>
        <Box
          sx={{
            width: isDesktop ? "50%" : "100%",
            minWidth: isDesktop ? "50%" : "100%",
          }}
        >
          <SummaryCard
            data={dashboardData.performance_summary}
            sx={{
              height: isDesktop ? "400px" : "auto",
              minHeight: "350px",
            }}
          />
        </Box>
      </Box>
    </Box>
  );
}

export default Dashboard;
